export default {
  truncateTime(date: Date): Date {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
  },
  isBeforeDateOnly(left: Date, right: Date): boolean {
    return this.truncateTime(left).getTime() < this.truncateTime(right).getTime();
  },
  isAfterDateOnly(left: Date, right: Date): boolean {
    return this.truncateTime(left).getTime() > this.truncateTime(right).getTime();
  },
  clampDateOnly(date: Date, minDate?: Date, maxDate?: Date): Date {
    const truncatedDate = this.truncateTime(date);

    if (minDate && this.isBeforeDateOnly(truncatedDate, minDate)) {
      return this.truncateTime(minDate);
    }

    if (maxDate && this.isAfterDateOnly(truncatedDate, maxDate)) {
      return this.truncateTime(maxDate);
    }

    return truncatedDate;
  },
};
